export const ValidationReasonFeatureNotPolygon = "Feature is not a Polygon";
export const ValidationReasonModeMismatch =
	"Feature mode property does not match the mode being added to";
